<cb-dialog dialogHeading="{{ getHeading() }}">
    <form class="flex-col flex" #loginForm="ngForm">
        @if (mode !== 'resetPassword') {
            <cb-input
                type="text"
                name="username"
                label="Username"
                [maxlength]="100"
                [required]="true"
                [(ngModel)]="mappedItem.portalUsername"
            ></cb-input>
        }
        @if (mode !== 'changeUsername') {
            <cb-input
                type="text"
                name="password"
                label="Password"
                [minlength]="9"
                [maxlength]="100"
                [required]="true"
                [(ngModel)]="password"
            ></cb-input>
        }
    </form>
    <div actions>
        <span class="flex"></span>
        <button
            mat-raised-button
            [disabled]="!loginForm.dirty || !loginForm.valid"
            color="primary"
            (click)="save()"
        >
            Create Login
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
